<template>
    <div>
        <b-modal
            id="createEstimateModal"
            ref="createEstimateModal"
            :lazy="true"
            :title="title"
            title-tag="h2"
        >
            <!-- Modal Form -->
            <transition name="slide-fade">
                <estimate
                    ref="estimate"
                    v-if="page == 'estimate' || page == 'duplicate'"
                    :data="data"
                    :page="page"
                    :client="client"
                    @loading="loading = true"
                    @loaded="loading = false"
                    @preventConvert="preventConvert"
                    class="pl-2"
                />
                <bundle
                    ref="bundle"
                    v-if="page == 'bundle'"
                    :data="bundle_data"
                    :app-data="data"
                    :isEstimate="data.isEstimate"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class="pl-2"
                />
            </transition>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.createEstimateModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <div v-else>
                        <b-btn
                            @click="back"
                            v-if="page != 'estimate' && page != 'duplicate'"
                            variant="primary"
                            >Back</b-btn
                        >&nbsp;
                        <b-btn
                            @click="save"
                            v-if="page == 'bundle' || isBundle"
                            :disabled="
                                (page == 'bundle' &&
                                    bundle_data.selectedElements.length ===
                                        0) ||
                                disableButton
                            "
                            variant="primary"
                            >Save</b-btn
                        >
                        <b-btn @click="next" v-else variant="primary"
                            >Next</b-btn
                        >
                    </div>
                </div>
            </div>
        </b-modal>
        <multipleRequisitionForm ref="multipleRequisitionFormWindow" />
    </div>
</template>
<style></style>
<script>
import Estimate from "@/components/billing-estimate/estimate-new-duplicate.vue";
import Bundle from "@/module/commons/bundle/bundle";
import BillingEstimateServices from "@/services/billing/billing-estimate.js";
import MultipleRequisitionForm from "@/module/commons/print_multiple_requisition_form.vue";
import ScheduleHelper from "@/module/schedule/helper";
export default {
    components: {
        Estimate,
        Bundle,
        MultipleRequisitionForm
    },
    mixins: [ScheduleHelper],
    props: {
        client: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            page: "estimate",
            title: "New Estimate",
            data: {
                id: null,
                isShortcut: 1,
                title: "Estimate",
                isEstimate: true,
                client: null,
                patient: null,
                location: null,
                start: null,
                expire: null,
                bundle_id: [],
                note: null,
                status: 0,
                action_status: 0,
                staff: null,
                isDefaultProvider: false
            },
            bundle_data: {
                bundle_id: null,
                selectedElements: [],
                elements: []
            },
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            loading: false,
            duplicateData: null,
            disableButton: false
        };
    },
    computed: {
        isBundle() {
            if (this.data.bundle_id.length > 0) {
                return false;
            }

            return true;
        }
    },
    methods: {
        preventConvert(status) {
            this.disableButton = status;
        },
        open(duplicate = null) {
            this.datePickerOptions.format = this.getDateFormat();

            this.page = "estimate";
            if (duplicate) {
                this.page = "duplicate";
                this.data.title = duplicate.title
                    ? duplicate.title + " (Copy)"
                    : "Estimate (Copy)";
                this.title = "Duplicate Estimate";
                this.data.duplicateId = duplicate.id;
                this.duplicateData = duplicate;
            }
            //to prevent provider field set to current staff
            //this.data.staff = this.$root.currentActor;

            this.$refs.createEstimateModal.show();
        },
        next() {
            let self = this;
            let proceed = true;
            if (self.page == "estimate") {
                self.$refs.estimate.$validator.validateAll().then(result => {
                    if (result) {
                        if (!self.data.start) {
                            proceed = false;
                        } else {
                            if (!moment.isMoment(self.data.start)) {
                                self.data.start = moment(
                                    self.data.start,
                                    self.datePickerOptions.format
                                );
                            }
                        }

                        if (!self.data.expire) {
                            proceed = false;
                        } else {
                            if (!moment.isMoment(self.data.expire)) {
                                self.data.expire = moment(
                                    self.data.expire,
                                    self.datePickerOptions.format
                                );
                            }
                        }

                        if (proceed) {
                            self.bundle_data.bundle_id = self.data.bundle_id;

                            self.page = "bundle";
                            self.title = "New Bundle";

                            $(".modal-content").removeAttr("tabindex");
                        }
                    }
                });
            }
        },
        back() {
            if (this.page == "bundle") {
                this.page = "estimate";
                this.title = "New Estimate";
            }
        },
        async save() {
            let self = this;
            let promise = true;
            let response = null;
            let proceed = true;
            self.loading = true;

            if (self.page == "bundle") {
                promise = await self.$refs.bundle.$validator.validateAll();
            } else {
                promise = await self.$refs.estimate.$validator.validateAll();
            }

            if (promise) {
                if (!self.data.start || !self.data.expire) {
                    proceed = false;
                }

                if (proceed && this.page != "duplicate") {
                    response = await this._saveEstimate(
                        self.data,
                        self.bundle_data
                    );

                    if (response.state == 1) {
                        self._message(response.message, "danger");
                        self.loading = false;
                    } else {
                        self.$refs.createEstimateModal.hide();
                        if (response.action_response) {
                            self.loading = false;

                            let show_success = true;
                            let show_error = true;
                            for (
                                let i = 0;
                                i < self.data.action_response.length;
                                i++
                            ) {
                                $.each(self.data.action_response[i], function (
                                    key,
                                    value
                                ) {
                                    if (key == "uri") {
                                        window.location = value;
                                    }
                                    if (
                                        key == "success" &&
                                        show_success == true
                                    ) {
                                        show_error = true;
                                        self._message(value);
                                    }
                                    if (key == "error" && show_error == true) {
                                        show_error = false;
                                        self._message(value, "danger");
                                    }
                                });
                            }
                        }

                        //if have requisition form
                        if (
                            (response.lab_ids && response.lab_ids.length > 0) ||
                            response.idexx_lab_id
                        ) {
                            let print_lab_params = {
                                idexx_lab_id: response.idexx_lab_id,
                                idexx_url: response.idexx_url,
                                lab_ids: response.lab_ids,
                                source: response.lab_source,
                                module: "appointment"
                            };

                            self._print_lab_order(print_lab_params).then(
                                function (lab_response) {
                                    if (lab_response.idexx_iframe) {
                                        //load idexx iframe
                                        lab_response.module_url =
                                            print_lab_params.module_url;
                                        lab_response.module =
                                            print_lab_params.module;

                                        self.$root.$emit(
                                            "call_idexx_iframe",
                                            lab_response
                                        );
                                    } else {
                                        //load requisition form modal
                                        lab_response.module_url =
                                            print_lab_params.module_url;
                                        lab_response.module =
                                            print_lab_params.module;

                                        self.$root.$emit(
                                            "call-multirequsition-modal",
                                            lab_response
                                        );
                                    }
                                }
                            );
                        } else {
                            if (response.discount_change) {
                                window.location =
                                    process.env.APPS +
                                    "index.php/" +
                                    response.url +
                                    "?dc=1";
                            } else {
                                window.location =
                                    process.env.APPS +
                                    "index.php/" +
                                    response.url;
                            }
                        }

                        return response;
                    }
                } else if (proceed && this.page == "duplicate") {
                    let params = {
                        old_id: this.duplicateData.id,
                        default_patient_id: this.data.patient
                            ? this.data.patient.id
                            : "",
                        default_provider_id: this.data.staff
                            ? this.data.staff.id
                            : "",
                        start: this.data.start,
                        start_time: this._now().toFormat("h:mm a"),
                        expire: this.data.expire,
                        title: this.data.title,
                        note: this.data.note ? String(this.data.note) : "",
                        status: String(this.duplicateData.status),
                        location_id: this.data.location
                            ? this._parseLocation(this.data.location)
                            : String(0),
                        client_id: this.data.client ? this.data.client.id : ""
                    };

                    BillingEstimateServices.duplicateEstimate(params)
                        .then(response => {
                            if (
                                response.message.code == 200 &&
                                response.resource
                            ) {
                                // redirect to the new estimate page - in vue
                                this.$router.push({
                                    name: "estimate",
                                    params: { id: response.resource.encoded_id }
                                });
                            } else {
                                this._message(response.message, "danger");
                                self.loading = false;
                            }
                        })
                        .catch(error => {
                            this._message(
                                "Error : Unable to duplicate estimate",
                                "danger"
                            );
                            console.error(error);
                            self.loading = false;
                        });
                } else {
                    self.loading = false;
                }
            } else {
                self.loading = false;
            }
        }
    }
};
</script>
